import {
    OFFICE_PRODUCT_GALLERY_OPEN,
    OFFICE_PRODUCT_GALLERY_CLOSE,
} from "../actions/officeProductGallery.actions";

const initialState = {
    open: false,
    officeId: "",
    productId: "",
    title: "",
    thumbnail: "",
    source: "",
    openedAt: null,
};

export default function officeProductGalleryReducer(state = initialState, action) {
    switch (action.type) {
        case OFFICE_PRODUCT_GALLERY_OPEN:
            return {
                ...initialState,
                ...(action.payload || {}),
                open: true,
            };

        case OFFICE_PRODUCT_GALLERY_CLOSE:
            return initialState;

        default:
            return state;
    }
}
